import React from 'react';
import { Dialog, DialogTitle, DialogActions, Button, Icon } from '@mui/material';
import { styled } from '@mui/material/styles';
import { get } from 'global/lib/lodash';

const PaddedDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    padding: 15,
  },
});

const StyledDialogActions = styled(DialogActions)({
  paddingTop: 20,
  alignItems: 'center',
  justifyContent: 'center',
});

const ActionIcon = styled(Icon)({
  marginRight: 5,
});

export default (props) => {
  const { useDialog, title, children, onClose, open } = props;

  if (useDialog) {
    const includeButtons = get(props, 'includeButtons', true);

    return (
      <PaddedDialog open={open} onClose={onClose} classes={props.classes}>
        {title && <DialogTitle>{title}</DialogTitle>}

        {children}

        {includeButtons && (
          <StyledDialogActions>
            <Button onClick={onClose} variant="contained" color="secondary">
              <ActionIcon>check</ActionIcon>
              APPLY
            </Button>
          </StyledDialogActions>
        )}
      </PaddedDialog>
    );
  }

  return <div style={{ width: '100%', height: '100%' }}>{children}</div>;
};
